export default __webpack_public_path__ + "static/media/accounts.f88ef9b1.png";